var interfaces;
(function (interfaces) {
    ;
})(interfaces || (interfaces = {}));
export { interfaces };
//# sourceMappingURL=interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/interfaces/interfaces.js
// module id = 1740
// module chunks = 0